import { API_PREFIX, API_URL, useAuthorizationMutation } from "@shared/api";
import { LOCAL_STORAGE } from "@shared/constants";
import { getApplicationTelegramData, logIn } from "@shared/utils";
import { Loader } from "@widgets/Loader";
import { FC, ReactNode, useEffect } from "react";

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
  const [authorization, { isLoading: authorizationIsLoading }] =
    useAuthorizationMutation();
  const handleLogin = async () => {
    try {
      const { data: response, error } = await authorization({
        applicationTelegramDataDto: getApplicationTelegramData(),
      });

      if (error) throw new Error("User authorization failed.");
      logIn(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleLogout = async (visibilityState: DocumentVisibilityState) => {
    try {
      if (visibilityState !== "hidden") return;

      const sessionId = localStorage.getItem(LOCAL_STORAGE.SessionId) || "";
      const url = `${API_URL}${API_PREFIX}/auth/${sessionId}`;

      const blob = new Blob([JSON.stringify({ sessionId })], {
        type: "application/json",
      });

      navigator.sendBeacon(url, blob);
    } catch (err) {
      console.error(err);
    }
  };

  const handleVisibilityChange = (e: Event) => {
    const visibilityState = (e.target as Document).visibilityState;
    handleLogout(visibilityState);
  };

  useEffect(() => {
    handleLogin();
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  if (
    authorizationIsLoading ||
    !localStorage.getItem(LOCAL_STORAGE.RefreshToken)
  )
    return <Loader />;
  return <>{children}</>;
};
